import gql from "graphql-tag";

export const MY_TIME_REJECT_REQUEST = gql`
  mutation rejectMyTimeRequest($_id: String!, $message: String) {
    rejectMyTimeRequest(_id: $_id, message: $message) {
      result
      message
    }
  }
`;
